import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import MultiSelect from "../../components/DataEntry/MultiSelect";
import { useLocation, useParams } from "react-router";
import { savePathToLocalStorage } from "../../utils/helpers";

const SettingsMain = () => {
  const handleClick = () => {
    alert("Test");
  };
  savePathToLocalStorage();

  // const handleChange = (e) => {
  //   setSelectedItems((prevArray) => [...prevArray, e]);
  // };

  return (
    <div className="settings-main main-content">
      <Header title="Settings" />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "2rem 2rem 0 0",
          cursor: "pointer",
        }}
      >
        <EditIcon onClick={handleClick} />
      </div>
      <div>
        <p style={{ textTransform: "uppercase" }}>To be implemented</p>
      </div>
    </div>
  );
};

export default SettingsMain;
